import { getBrandDefaultCurrency } from '../../shared/utils/brandCurrency';

/** Canonical payroll module defaults — synced via useSalairesConfig / patchSettings. */
export const DEFAULT_SALARIES_CONFIG = {
  monthlyWorkingDays: 30,
  annualLeaveDays: 21,
  paidHolidaysDays: 0,
  overtimeRate: 1.5,
  nightShiftRate: 1.5,
  gosiEmployeeRate: 9.75,
  gosiEmployerRate: 12.75,
  gosiMaxBasic: 45000,
  gosiExpatEmployerRate: 2,
  sanedEmployeeRate: 1,
  sanedEmployerRate: 1,
  housingAllowancePct: 25,
  transportAllowance: 1500,
  mobileAllowance: 500,
  foodAllowance: 800,
  autoCalculateDeductions: true,
  paymentDay: 7,
  wpsPaymentDayAlt: 27,
  autoGeneratePayslips: true,
  requireApproval: true,
  paymentMethod: 'bank_transfer',
  wpsEnabled: true,
  calculateBonusesAuto: true,
  notifyBeforePayment: true,
  notifyDaysBeforePayment: 3,
  notifyPayslipsReady: true,
  emailPayslips: true,
  requirePinForPayroll: true,
  logAllChanges: true,
  encryptSalaryData: true,
  defaultView: 'stats',
  showNetSalary: true,
  currencyDisplay: getBrandDefaultCurrency(),
  itemsPerPage: 50,
  advanceReferencePrefix: 'AVA',
  loanReferencePrefix: 'LOA',
  transferReferencePrefix: 'VIR',
};

/** Map logical entity keys → salaries config field names for getEntityPrefix. */
export const SALARIES_ENTITY_PREFIX_MAP = {
  payrollAdvance: 'advanceReferencePrefix',
  payrollLoan: 'loanReferencePrefix',
  payrollTransfer: 'transferReferencePrefix',
};

/** Map payroll config prefixes into settings.configuration.entityPrefixes keys. */
export function buildSalariesEntityPrefixes(config) {
  const c = normalizeSalariesConfig(config);
  return {
    payrollAdvance: c.advanceReferencePrefix,
    payrollLoan: c.loanReferencePrefix,
    payrollTransfer: c.transferReferencePrefix,
  };
}

export function normalizeSalariesConfig(raw = {}) {
  const merged = { ...DEFAULT_SALARIES_CONFIG, ...(raw && typeof raw === 'object' ? raw : {}) };
  return {
    ...merged,
    monthlyWorkingDays: Number(merged.monthlyWorkingDays) || DEFAULT_SALARIES_CONFIG.monthlyWorkingDays,
    paymentDay: Number(merged.paymentDay) || DEFAULT_SALARIES_CONFIG.paymentDay,
    itemsPerPage: Number(merged.itemsPerPage) || DEFAULT_SALARIES_CONFIG.itemsPerPage,
    advanceReferencePrefix: String(merged.advanceReferencePrefix || DEFAULT_SALARIES_CONFIG.advanceReferencePrefix).trim(),
    loanReferencePrefix: String(merged.loanReferencePrefix || DEFAULT_SALARIES_CONFIG.loanReferencePrefix).trim(),
    transferReferencePrefix: String(merged.transferReferencePrefix || DEFAULT_SALARIES_CONFIG.transferReferencePrefix).trim(),
  };
}
